import React, { useEffect, useState } from "react";
import { Field } from "@bwevents/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import { Validations } from "../services/Validations";
import "./InputPassword.scss";

export default function InputPassword({
  initialValue,
  emmitValue,
  emmitValid,
  label,
  placeholder,
  equalTo,
  typeConfirm = false,
  forceInvalidConfirm = false,
  children,
}) {
  const [typeInput, setTypeInput] = useState("password");
  const [password, setPassword] = useState();
  const [passwordIsValid, setPasswordIsValid] = useState();
  const passwordValid = (e) => {
    return Validations.customPassword(e);
  };
  const changeTypePassword = () => {
    if (typeInput === "password") {
      setTypeInput("text");
    } else if (typeInput === "text") {
      setTypeInput("password");
    }
  };
  const setValue = (e) => {
    setPassword(e);
    emmitValue(e);
    if (typeConfirm) {
      emmitValid(e === equalTo);
      setPasswordIsValid(e === equalTo);
    } else {
      if (e) {
        emmitValid(passwordValid(e));
        setPasswordIsValid(passwordValid(e));
      } else {
        emmitValid(false);
        setPasswordIsValid(false);
      }
    }
  };
  useEffect(() => {
    if (initialValue) {
      setPassword(initialValue);
      emmitValid(passwordValid(initialValue));
      setPasswordIsValid(passwordValid(initialValue));
    }
  }, [initialValue, emmitValid]);

  return (
    <div className="bw-event-input-password">
      <div className="wrapper-field-password">
        <Field
          type={typeInput}
          label={label}
          placeholder={placeholder}
          value={password}
          setValue={setValue}
          invalid={
            (forceInvalidConfirm && password) ||
            password === "" ||
            passwordIsValid === false
          }
          invalidMessage={
            forceInvalidConfirm && password
              ? "Password fields do not match"
              : (password === "" ? label + " is required." : "") ||
                (passwordIsValid === false
                  ? typeConfirm
                    ? "Password fields do not match"
                    : label + " is invalid."
                  : "")
          }
          feedback={null}
          className="bw-event-input"
        />
        <button className="eye-password" onClick={() => changeTypePassword()}>
          {typeInput === "password" ? (
            <FontAwesomeIcon icon={faEye} style={{ color: "#666666" }} />
          ) : (
            <FontAwesomeIcon icon={faEyeSlash} style={{ color: "#666666" }} />
          )}
        </button>
      </div>
      {children}
    </div>
  );
}
